import classNames from 'classnames';
import styles from './ArticleAuthor.module.scss';
import { Link, LinkProps } from 'ui/components/1-atoms/Action/Link/Link';
import { Paragraph } from 'ui/components/1-atoms/Paragraph/Paragraph';
import { Picture } from 'ui/components/1-atoms/Media/Picture/Picture';
import LinkedInIcon from 'ui/icons/icon_linkedin.svg';
import MailIcon from 'ui/icons/icon_mail.svg';
import { Icon } from 'ui/components/1-atoms/Media/Icon/Icon';
export interface ArticleAuthorProps {
	className?: string;
	fullName?: string;
	workTitle?: string;
	email: string;
	bio?: string;
	showBio?: boolean;
	linkedIn?: LinkProps;
	image?: {
		url: string;
		altText: string;
		focalPoint?: { left: number; top: number };
	};
}

export const ArticleAuthor: React.FC<ArticleAuthorProps> = ({ className, fullName, workTitle, email, linkedIn, image, bio, showBio = false }) => (
	<div className={classNames(styles.ArticleAuthor, className)}>
		<div className={styles.ArticleAuthor_imageAndSocial}>
			{image.url && (
				<div className={styles.ArticleAuthor_image}>
					<Picture
						imageCropping="cover"
						url={image.url}
						altText={image.altText}
						roundBorder={true}
						sizes="80px"
						focalPoint={image.focalPoint}
					/>
				</div>
			)}
			<div className={styles.ArticleAuthor_social}>
				{email && (
					<Link className={classNames(styles.ArticleAuthor_email)} href={`mailto:${email}`}>
						<Icon size="xl">
							<MailIcon />
						</Icon>
					</Link>
				)}

				{linkedIn && (
					<Link className={styles.ArticleAuthor_soMe} target={linkedIn.target} href={linkedIn.href}>
						<Icon size="xl">
							<LinkedInIcon />
						</Icon>
					</Link>
				)}
			</div>
		</div>

		{fullName && (
			<Paragraph bold className={styles.ArticleAuthor_name}>
				{fullName}
			</Paragraph>
		)}
		{workTitle && <Paragraph className={styles.ArticleAuthor_title}>{workTitle}</Paragraph>}

		{bio && showBio && <Paragraph className={styles.ArticleAuthor_bio}>{bio}</Paragraph>}
	</div>
);
